import { createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const servicePlugin = createPlugin({
  id: 'service',
  routes: {
    root: rootRouteRef,
  },
});

export const ServicePage = servicePlugin.provide(
  createRoutableExtension({
    name: 'ServicePage',
    component: () =>
      import('./ServiceComponent').then(m => m.ServiceComponent),
    mountPoint: rootRouteRef,
  }),
);
